import { useState } from "react";
import { useParams } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore"; 
import Lang from './Lang';


export default function UninstallSurveyGeneral(props){
 const {language} = useParams();
    let lang = language;
    document.title = "Image downloader";
    const locals = ['pt','es','fr','de','it','hu','tr','ru','he','vi','th','ko','zh_CN','zh_TW','ja'];                
    if(!locals.includes(lang)){
      lang='en';
    }


const translation = {
  en: [
    "You uninstalled the extension",
    "We want to do better - Tell us what went wrong.",
    "I uninstalled the extension because...",
    "Submit",
    "Thank you for your feedback",
    "No issues, just not needed anymore",
    "Extension only downloaded small versions of images (thumbnails only)",
    "General issue",
    "(Optional)"
  ],

  de: [
    "Du hast die Erweiterung deinstalliert",
    "Wir möchten uns verbessern – sag uns, was schiefgelaufen ist.",
    "Ich habe die Erweiterung deinstalliert, weil...",
    "Senden",
    "Danke für dein Feedback",
    "Keine Probleme, ich brauche sie nicht mehr",
    "Die Erweiterung hat nur kleine Bildversionen heruntergeladen (nur Miniaturansichten)",
    "Allgemeines Problem",
    "(Optional)"
  ],

  es: [
    "Desinstalaste la extensión",
    "Queremos mejorar - Cuéntanos qué salió mal.",
    "Desinstalé la extensión porque...",
    "Enviar",
    "Gracias por tus comentarios",
    "Sin problemas, ya no la necesito",
    "La extensión solo descargó versiones pequeñas de las imágenes (solo miniaturas)",
    "Problema general",
    "(Opcional)"
  ],

  fr: [
    "Vous avez désinstallé l’extension",
    "Nous voulons nous améliorer - Dites-nous ce qui n’a pas fonctionné.",
    "J’ai désinstallé l’extension parce que...",
    "Envoyer",
    "Merci pour votre retour",
    "Aucun problème, je n’en ai plus besoin",
    "L’extension n’a téléchargé que des versions réduites des images (miniatures uniquement)",
    "Problème général",
    "(Facultatif)"
  ],

  it: [
    "Hai disinstallato l’estensione",
    "Vogliamo migliorare - Dicci cosa è andato storto.",
    "Ho disinstallato l’estensione perché...",
    "Invia",
    "Grazie per il tuo feedback",
    "Nessun problema, non ne ho più bisogno",
    "L’estensione ha scaricato solo versioni ridotte delle immagini (solo miniature)",
    "Problema generale",
    "(Facoltativo)"
  ],

  pt: [
    "Você desinstalou a extensão",
    "Queremos melhorar - Conte o que deu errado.",
    "Desinstalei a extensão porque...",
    "Enviar",
    "Obrigado pelo seu feedback",
    "Sem problemas, não preciso mais dela",
    "A extensão baixou apenas versões pequenas das imagens (somente miniaturas)",
    "Problema geral",
    "(Opcional)"
  ],

  ru: [
    "Вы удалили расширение",
    "Мы хотим стать лучше — расскажите, что пошло не так.",
    "Я удалил расширение потому что...",
    "Отправить",
    "Спасибо за ваш отзыв",
    "Нет проблем, оно мне больше не нужно",
    "Расширение загружало только уменьшенные версии изображений (только миниатюры)",
    "Общая проблема",
    "(Необязательно)"
  ],

  he: [
    "הסרת את התוסף",
    "אנחנו רוצים להשתפר - ספר לנו מה השתבש.",
    "הסרתי את התוסף כי...",
    "שלח",
    "תודה על המשוב שלך",
    "אין בעיות, פשוט לא צריך יותר",
    "התוסף הוריד רק גרסאות קטנות של התמונות (תמונות ממוזערות בלבד)",
    "בעיה כללית",
    "(אופציונלי)"
  ],

  hu: [
    "Eltávolítottad a bővítményt",
    "Szeretnénk fejlődni - mondd el, mi ment rosszul.",
    "Azért távolítottam el a bővítményt, mert...",
    "Küldés",
    "Köszönjük a visszajelzést",
    "Nincs probléma, már nincs rá szükségem",
    "A bővítmény csak kicsi képeket töltött le (csak bélyegképek)",
    "Általános probléma",
    "(Opcionális)"
  ],

  ja: [
    "拡張機能をアンインストールしました",
    "改善したいので、何が問題だったか教えてください。",
    "拡張機能をアンインストールした理由は...",
    "送信",
    "フィードバックありがとうございます",
    "問題なし、もう必要ありません",
    "拡張機能は小さいサイズの画像のみをダウンロードしました（サムネイルのみ）",
    "一般的な問題",
    "（任意）"
  ],

  ko: [
    "확장 프로그램을 삭제했습니다",
    "더 나아지고 싶습니다 - 무엇이 잘못되었는지 알려주세요.",
    "확장 프로그램을 삭제한 이유는...",
    "제출",
    "피드백 감사합니다",
    "문제 없음, 더 이상 필요하지 않음",
    "확장 프로그램이 작은 이미지 버전만 다운로드했습니다 (썸네일만)",
    "일반 문제",
    "(선택 사항)"
  ],

  tr: [
    "Uzantıyı kaldırdınız",
    "Daha iyi olmak istiyoruz - neyin yanlış gittiğini bize söyleyin.",
    "Uzantıyı kaldırdım çünkü...",
    "Gönder",
    "Geri bildiriminiz için teşekkürler",
    "Sorun yok, artık ihtiyacım yok",
    "Uzantı yalnızca küçük görsel sürümlerini indirdi (yalnızca küçük resimler)",
    "Genel sorun",
    "(İsteğe bağlı)"
  ],

  vi: [
    "Bạn đã gỡ tiện ích",
    "Chúng tôi muốn cải thiện - Hãy cho chúng tôi biết vấn đề là gì.",
    "Tôi đã gỡ tiện ích vì...",
    "Gửi",
    "Cảm ơn phản hồi của bạn",
    "Không có vấn đề, không cần nữa",
    "Tiện ích chỉ tải phiên bản nhỏ của hình ảnh (chỉ hình thu nhỏ)",
    "Vấn đề chung",
    "(Tùy chọn)"
  ],

  th: [
    "คุณได้ถอนการติดตั้งส่วนขยายแล้ว",
    "เราต้องการปรับปรุง - บอกเราว่าเกิดอะไรขึ้น",
    "ฉันถอนการติดตั้งส่วนขยายเพราะ...",
    "ส่ง",
    "ขอบคุณสำหรับความคิดเห็น",
    "ไม่มีปัญหา ไม่จำเป็นอีกต่อไป",
    "ส่วนขยายดาวน์โหลดเฉพาะภาพขนาดเล็ก (ภาพย่อเท่านั้น)",
    "ปัญหาทั่วไป",
    "(ไม่บังคับ)"
  ],

  zh_CN: [
    "您已卸载扩展程序",
    "我们希望改进 - 请告诉我们出了什么问题。",
    "我卸载扩展程序是因为...",
    "提交",
    "感谢您的反馈",
    "没有问题，不再需要了",
    "扩展程序只下载了小尺寸图片（仅缩略图）",
    "一般问题",
    "（可选）"
  ],

  zh_TW: [
    "您已解除安裝擴充功能",
    "我們希望改進 - 請告訴我們出了什麼問題。",
    "我解除安裝擴充功能是因為...",
    "提交",
    "感謝您的回饋",
    "沒有問題，不再需要了",
    "擴充功能只下載了小尺寸圖片（僅縮圖）",
    "一般問題",
    "（可選）"
  ]
};
const {version} = useParams();
const suffix="/"+version;
const { subject } = useParams();
document.title = subject+" - unistall survey";
document.body.style = "background-image: url('/assets/forest.webP'); background-repeat: no-repeat;  background-attachment: fixed; background-size: 100% 100%;";
const [submited, setSubmited] = useState(false);
const [body, setBody] = useState("");
const [uninstallReason, setUninstallReason] = useState("other");
let firstClick = true;
const submit = async (event) =>{
    event.preventDefault();

  let messageBody = "";

  if (uninstallReason === "no-issues") {
    messageBody = "[No issues]";
  }else if (uninstallReason === "small-images") {
    messageBody = "[Downloads thumbnails only] "+document.getElementById("issue_url")?.value || ""; 
  } else {
    messageBody = body;
  }
    if(messageBody!=="" && firstClick){
      firstClick = false;
        const docRef = await setDoc(doc(props.db, "emails",Date.now().toString()), {
            message: {
                subject: subject + " - unistall survey "+version+lang,
                html: messageBody,
            }
        });
    }
    setSubmited(true);
}
function bugHunt(){
  return(
    <>
If the reason you uninstalled the extension is because it didn’t work at all, 
you may be able to earn an $8 Amazon gift card by{" "}
<a href="/bug-hunt.html" target="_blank">
  participating
</a> in our bug hunt program.<br /><br />    </>
    )
}
if(submited){ return(<div className="u-s-page-header" style={{padding: "24px", margin: "48px", backgroundColor: "rgba(255, 255, 255, 0.9)"}}>{translation[lang][4]} :-{")"}</div>)}else{
    return(
                <div style={{direction: lang != 'he' ? 'ltr' : 'rtl'}}>
<div style={{backgroundColor: "rgba(111, 111, 111, 0.9)", marginTop:"64px", padding: "32px 16px 16px 16px", borderRadius: "16px"}}>
    <Lang suffix = {suffix} />
    <div className="u-s-page-header" style={{textAlign:"start", marginLeft: "16px"}}>{translation[lang][0]}</div>
    <div className="u-s-main-title" style={{marginLeft: "16px", fontFamily: "Helvetica" , fontSize: "2em"}}>
        <p>{translation[lang][1]}</p>
    </div>
    <span style={{color:"white"}}> 
        &nbsp;
    </span>
    <div className="u-s-container" style={{backgroundColor: "transparent", padding: "1em"}}>
        <form id="form" onSubmit={submit}>
    <select
  value={uninstallReason}
  onChange={(e) => setUninstallReason(e.target.value)}
>
  <option value="no-issues">{translation[lang][5]}</option>
  {subject==="image_downloader" &&(
  <option value="small-images">{translation[lang][6]}</option>
  )}
  <option value="other">{translation[lang][7]}</option>
</select>
    {uninstallReason === "small-images" && (
      <div>URL: <input id="issue_url" placeholder="URL" style={{ backgroundColor: "white", padding: "12px 20px", border: "none", borderRadius: "4px"}} />&nbsp; {translation[lang][8]}</div>
      )}
            {uninstallReason === "other" && (
            <textarea id="content" name="content" placeholder={translation[lang][2]}
                style={{height:"150px", width: "100%", padding: "12px", border: "1px solid #ccc", borderRadius: "4px", boxSizing: "border-box", resize: "vertical"}} onChange={(e) => setBody(e.target.value)}></textarea>
              )}
    {language=="en"&&subject=="image_downloader" ? bugHunt() : ""} 
            <input style={{ color: "white", padding: "12px 20px", border: "none", borderRadius: "4px", cursor: "pointer", marginTop: "16px",}} type="submit" value={translation[lang][3]} />
    
      </form>
    </div>
    
</div>   
</div>
    )
}
}
